import { Settings } from '../Settings';
import { $window, $body } from '../Constants';
import HtmlElement from './HtmlElement';
import NavSubHorizontal from './NavSubHorizontal';
import MetaBar from './MetaBar';


/**
 * Header
 */
const Header = (() => {
  // Constants
  const DATA_KEY = 'ig.header';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   */
  const Selector = {
    HEADER: 'header#header'
  };

  /**
   * Event
   */
  const Event = {
    RESIZE: `resize${EVENT_KEY}`,
    SCROLL: `scroll${EVENT_KEY}`
  };

  /**
   * Header
   *
   * @class
   * @augments HtmlElement
   */
  class Header extends HtmlElement {
    /**
     * @constructor
     *
     * @param { jQuery } $element
     */
    constructor($element) {
      super($element);

      this._transitionEnabled = false;
      this._isScrolled = false;
    }

    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._height = this.getHeight();
      this._metaBarHeight = MetaBar.getHeight();

      this._toggleScrolled();
      this._bindHandlers();
    }

    // Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        this._toggleScrolled();
      });

      $window.on(Event.SCROLL, () => {
        let newHeight = this.getHeight();

        if (NavSubHorizontal.exists() && this._height !== newHeight) {
          NavSubHorizontal.updateScrolledAt();
          this._height = newHeight;
        }

        this._toggleScrolled();
      });
    }

    /**
     * Toggles the scrolled state
     *
     * @return void
     */
    _toggleScrolled() {
      if ($window.width() > Settings.headerScrollToggleMinWidth && Settings.headerScrolledAt > 0) {
        // Add scrolled class when below headerScrolledAt value or remove when above
        if (!this._isScrolled) {
          if ($window.scrollTop() >= Settings.headerScrolledAt) {
            this.$element.addClass(Settings.classScrolled);

            if (Settings.hideMetaBarOnScrolled) {
              this.$element.css('transform', 'translate3d(0, -' + this._metaBarHeight + 'px, 0)');
            }

            this._isScrolled = true;

            if (NavSubHorizontal.exists()) {
              NavSubHorizontal.queueFunction(() => {
                NavSubHorizontal.updateScrolledAt();
                NavSubHorizontal.adjustTopValue();
              });

              let interval = setInterval(() => {
                NavSubHorizontal.adjustTopValue();
              }, 1);
              setTimeout(() => {
                clearInterval(interval);
              }, 300);
            }
          }
        } else {
          if ($window.scrollTop() < Settings.headerScrolledAt) {
            this.$element.removeClass(Settings.classScrolled);

            if (Settings.hideMetaBarOnScrolled) {
              this.$element.css('transform', 'translate3d(0, 0, 0)');
            }

            this._isScrolled = false;

            if (NavSubHorizontal.exists()) {
              NavSubHorizontal.queueFunction(() => {
                NavSubHorizontal.updateScrolledAt();
                NavSubHorizontal.adjustTopValue();
              });
            }
          }
        }
      }
    }

    // Getters

    /**
     * Returns the isScrolled property
     *
     * @return { boolean } _isScrolled
     */
    get isScrolled() {
      return this._isScrolled;
    }

    /**
     * Returns the metaBarHeight property
     *
     * @return { int } _metaBarHeight
     */
    get metaBarHeight() {
      return this._metaBarHeight;
    }
  }

  return Header._getElement($body.find(Selector.HEADER), Header);
})();

export default Header;
